module.exports = __webpack_public_path__ + "img/Detach.33e08beb.svg";